<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" @submit.native.prevent :label-width="labelWidth">
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005424')" prop="carrierName">
              <Input v-model.trim="pageParams.carrierName" clearable></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001522')">
              <local-tabButton :tabButtonList="statusList" @selectStatus="statusBtn"></local-tabButton>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button type="primary" @click="$refs['addSupplierLogisticsProvider'].initSupplierLogisticsProviderData('add')"
        v-if="getPermission('ymsSupplierCarrier_insert')">{{ $t('key1007108') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="510"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--新增物流商弹窗-->
    <addSupplierLogisticsProviderModal ref="addSupplierLogisticsProvider" @updateData="pageParamsStatus = true"></addSupplierLogisticsProviderModal>
    <!--查看物流渠道-->
    <supplierLogisticsChannels
      optionsType="selfOwnedLogistics"
      ref="logisticsChannelsDrawer"
      @updateData="pageParamsStatus = true">
    </supplierLogisticsChannels>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {ENABLEDISABLESTATUS} from "@/utils/enum";
import {isValueEmpty} from "@/utils/common";
import addSupplierLogisticsProviderModal from "@/views/supplier/components/warehouseLogistics/addSupplierLogisticsProviderModal.vue";
import supplierLogisticsChannels from "@/views/supplier/components/warehouseLogistics/supplierLogisticsChannels.vue";

export default {
  name: 'selfOwnedLogisticsList',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        carrierName: '',
        status: null,
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      statusList: ENABLEDISABLESTATUS,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005416'),
          key: 'carrierName',
          minWidth: 150,
          align: 'center',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002157'),
          key: 'status',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            let typeList = [
              {type: 'error', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')},
              {type: 'success', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462')}
            ];
            let status = params.row.status;
            if (!isValueEmpty(status)) {
              return h('Badge', {
                props: {
                  status: typeList[status].type,
                  text: typeList[status].text || '-'
                },
                class: status === 0 ? 'stopStatus' : ''
              });
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          minWidth: 180,
          align: 'center',
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 210,
          render: (h, params) => {
            let status = params.row.status;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000669'),
                    show: v.getPermission('ymsSupplierCarrier_update'),
                    clickFn: () => {
                      v.$refs['addSupplierLogisticsProvider'].initSupplierLogisticsProviderData('edit', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005257'),
                    show: v.getPermission('ymsWarehouse_update'),
                    clickFn: () => {
                      v.$refs['logisticsChannelsDrawer'].getSupplierLogisticsChannelData(params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: status === 0 && v.getPermission('ymsSupplierCarrier_update'),
                    color: '#20c711',
                    clickFn: () => {
                      v.operationHandel('enable', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: status === 1 && v.getPermission('ymsSupplierCarrier_update'),
                    color: '#ed4014',
                    clickFn: () => {
                      v.operationHandel('disable', params.row);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
    };
  },
  created() {
    this.reset();
    this.search();
  },
  methods: {
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置数据
    reset() {
      let v = this;
      v.statusBtn(0, null);
      v.$nextTick(() => {
        v.$refs['pageParams'].resetFields();
      });
      v.search();
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsSupplierCarrier_queryForOwnCarriers')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsSupplierCarrier_queryForOwnCarriers, v.pageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            } else {
              v.tableLoading = false;
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 选取状态类型
    statusBtn(index, value) {
      let v = this;
      v.pageParams.status = value;
      v.statusList.forEach((n, i) => {
        n.selected = i === index;
      });
    },
    // 启用、停用仓库按钮
    operationHandel(type, obj) {
      let v = this;
      const configMap = {
        enable: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003567'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007126'),
          successText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002485')
        },
        disable: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002470'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007127'),
          successText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002486')
        }
      };
      const config = configMap[type];
      if (config) {
        let {title, content, successText} = config;
        v.$Modal.confirm({
          title: title,
          content: content,
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000543'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            let {carrierId, carrierName} = obj;
            let query = {
              carrierId: carrierId,
              carrierName: carrierName,
              status: type === 'disable' ? 0 : 1
            };
            v.axios.post(api.post_ymsSupplierCarrier_update, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.pageParamsStatus = true;
                v.$Message.success(successText);
              }
            });
          }
        });
      }
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    addSupplierLogisticsProviderModal,
    supplierLogisticsChannels
  }
};
</script>

<style lang="less">

</style>
